export default __webpack_public_path__ + "static/media/48.cf1878df.jpeg";